//type can be any register, login, field
export function PostPhone(type, userData){
    // console.log("object", userData)
let BaseUrl = "https://mnm.nettvnepal.com.np/api/net-tv/"
// console.log("data", userData.password)
let formdata = new FormData();
    formdata.append("phone", userData.phone);
    formdata.append("password",userData.password );
return new Promise((resolve,reject) => {
    fetch(BaseUrl + type,{
    method: "POST",
    // headers : {
    //     'Content-Type' : 'application/json',
    //     'Accept' : 'application/json',
    // },
    body: formdata
    })
    .then((response) => 
    response.json())
    .then((res) =>{
        resolve(res)
    })
    .catch((error) => {
        reject(error);
    });
});



    }